export const FAMILY_SYNC_CONFIG = {
  endpoint: 'https://household-items-sync.ali-raza-fmt.workers.dev',
  token: '539d6147ceb8b75999cc045c2449ddec4209274f9427268d'
} as const;
